import Vue from 'vue'
import App from './App.vue'

import './assets/common.less'
import "./assets/tailwind.css"
import "./assets/common-color.less"
import dataV from '@jiaminghi/data-view'
import store from './store'
import router from './router'

import axios from "./utils/request";
import ComponentSubtitle from "./components/datav/ComponentSubtitle.vue"
Vue.prototype.$axios = axios
import {
  themeColor
} from './constant/color';
Vue.prototype.$color = themeColor;

import animated from 'animate.css'
import 'vue2-animate/dist/vue2-animate.min.css';
import {
  Button,
  Select,
  Dialog,
  Input,
  Message,
  Table,
  TableColumn,
  Link,
  Descriptions,
  DescriptionsItem,
  Divider,
  Tag,
  Pagination,
  Image,
  Tabs,
  TabPane,
  Card,
  Carousel,
  CarouselItem,
  Empty,
  Tooltip
} from 'element-ui';

Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component(Dialog.name, Dialog);
Vue.component(Input.name, Input);
Vue.component(Message.name, Message);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Link.name, Link);
Vue.component(Descriptions.name, Descriptions);
Vue.component(DescriptionsItem.name, DescriptionsItem);
Vue.component(Divider.name, Divider);
Vue.component(Tag.name, Tag);
Vue.component(Pagination.name, Pagination);
Vue.component(Image.name, Image);
Vue.component(Tabs.name, Tabs);
Vue.component(TabPane.name, TabPane);
Vue.component(Card.name, Card);
Vue.component(Carousel.name, Carousel);
Vue.component(CarouselItem.name, CarouselItem);
Vue.component(Empty.name, Empty);
Vue.component(Tooltip.name, Tooltip);


Vue.component("ComponentSubtitle", ComponentSubtitle);
import FSelect from "./components/common/f-select.vue";
Vue.component("f-select", FSelect)
Vue.use(animated)


Vue.config.productionTip = false

Vue.use(dataV)

import autoScroll from "./utils/instruct"
Vue.use(autoScroll)

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import {
  EditionPayDialog
} from "./dialog"
Vue.prototype.$EditionEmptyDialog = EditionPayDialog; //挂载到vue实例上，可以全局使用了

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
